import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";

class TextAreaField extends Component {
  render() {
    const {
      name,
      label,
      required,
      placeholder,
      values = {},
      disabled = false,
      errors = {},
      touched = {},
      handleBlur,
      handleChange,
      classes = "",
      validation = {},
      formatting = {},
      styles = {},
    } = this.props;
    const uniqueId = _.uniqueId();
    return (
      <div className={`field ${errors[name] && touched[name] ? "error" : ""}`}>
        <label
          htmlFor={`${name}__${uniqueId}`}
          className="control-label"
          title={errors[name]}
        >
          {label}
          {required && <span className="text-danger">*</span>}
        </label>
        <textarea
          id={`${name}__${uniqueId}`}
          name={name}
          className={classes || "control-item"}
          value={values[name]}
          onChange={handleChange}
          onBlur={handleBlur}
          style={styles}
          ref={(c) => {
            this.field = c;
          }}
          validation={{ required, ...validation }}
          formatting={{ ...formatting }}
          placeholder={placeholder}
          disabled={disabled}
        />
        {errors[name] && touched[name] ? (
          <span className="error-message">{errors[name]}</span>
        ) : null}
      </div>
    );
  }
}

TextAreaField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  values: PropTypes.shape({}),
  disabled: PropTypes.bool,
  errors: PropTypes.shape({}),
  touched: PropTypes.shape({}),
  handleBlur: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  classes: PropTypes.string,
  validation: PropTypes.shape({}),
  formatting: PropTypes.shape({}),
  styles: PropTypes.shape({}),
};

TextAreaField.defaultProps = {
  label: "",
  required: false,
  placeholder: "",
  values: {},
  disabled: false,
  styles: {},
  errors: {},
  touched: {},
  classes: "",
  validation: {},
  formatting: {},
};

export default TextAreaField;
